// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA7_comp__qLVQj"};